import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import {
  Container,
  ModalContainer,
  ModalHeader,
  ContainerBoxUploadReenviar,
} from './styles';

import AlertaReenviarLinhaDeCuidado from './alerta';
import BoxUploadReenviar from './boxUpload';

const ModalReenviarLinhaDeCuidado = ({
  modalReenviar,
  setModalReenviar,
  linhaDeCuidadoValue,
  periodoSelecionado,
}) => {
  const [confirmaReenvio, setConfirmaReenvio] = useState(false);
  const [reenvioConfirmado, setReenvioConfirmado] = useState(false);
  const [confirmaReenvioCheck, setConfirmaReenvioCheck] = useState(false);

  const [senha, setSenha] = useState(false);

  const [nomeLinhaDeCuidado, setNomeLinhaDeCuidado] = useState('');

  useEffect(() => {
    if (linhaDeCuidadoValue) {
      const titleIndicador =
        (linhaDeCuidadoValue === 'indicadores_painel_geral' &&
          'Indicadores do Painel Geral') ||
        (linhaDeCuidadoValue === 'acidente_vascular_cerebral' &&
          'Acidente Vascular Cerebral - AVC') ||
        (linhaDeCuidadoValue === 'artropatia_de_quadril' &&
          'Artropatia de Quadril') ||
        (linhaDeCuidadoValue === 'cancer_de_mama' && 'Câncer de Mama') ||
        (linhaDeCuidadoValue === 'cancer_de_prostata' &&
          'Câncer de Próstata') ||
        (linhaDeCuidadoValue === 'sepse_e_choque_septico' &&
          'Sepse e Choque Séptico') ||
        (linhaDeCuidadoValue === 'sindrome_coronariana_aguda' &&
          'Síndrome Coronariana Aguda - SCA');

      setNomeLinhaDeCuidado(titleIndicador);
    }
  }, [linhaDeCuidadoValue]);

  const handleCancel = () => {
    setModalReenviar(false);
    setTimeout(() => {
      setConfirmaReenvio(false);
      setReenvioConfirmado(false);
      setConfirmaReenvioCheck(false);
    }, 300);
  };

  return (
    <Container>
      <Modal
        visible={modalReenviar}
        onCancel={handleCancel}
        centered
        footer={null}
        width="480px"
      >
        {confirmaReenvio ? (
          <ModalContainer>
            <ModalHeader>
              <h2>
                <span>Reenviar arquivo</span> para a <br />
                <span className="boldGreen">
                  Linha de Cuidado de {nomeLinhaDeCuidado}
                </span>
                <br />e competência
                <span className="boldGreen"> {periodoSelecionado}</span>
              </h2>
            </ModalHeader>

            <ContainerBoxUploadReenviar>
              <p>
                Use o botão abaixo para fazer upload <br /> do novo arquivo
                (.csv).
              </p>
              <BoxUploadReenviar
                linhaDeCuidadoValue={linhaDeCuidadoValue}
                periodoSelecionado={periodoSelecionado}
                senha={senha}
              />
            </ContainerBoxUploadReenviar>
          </ModalContainer>
        ) : (
          <AlertaReenviarLinhaDeCuidado
            setConfirmaReenvio={setConfirmaReenvio}
            reenvioConfirmado={reenvioConfirmado}
            setReenvioConfirmado={setReenvioConfirmado}
            confirmaReenvioCheck={confirmaReenvioCheck}
            setConfirmaReenvioCheck={setConfirmaReenvioCheck}
            handleCancel={handleCancel}
            senha={senha}
            setSenha={setSenha}
            periodoSelecionado={periodoSelecionado}
            linhaDeCuidadoValue={linhaDeCuidadoValue}
          />
        )}
      </Modal>
    </Container>
  );
};

ModalReenviarLinhaDeCuidado.propTypes = {
  modalReenviar: PropTypes.bool.isRequired,
  setModalReenviar: PropTypes.func.isRequired,
  periodoSelecionado: PropTypes.string.isRequired,
};

export default ModalReenviarLinhaDeCuidado;
